module.exports = __webpack_public_path__ + "static/media/Growth_Groups_square.b458c9c7.png";